export default __webpack_public_path__ + "static/media/cryptoLogo.249bb59b.svg";